<template>
  <div class="loading-container" v-show="load">
    <div class="waterfall">
      <div id="first">
        <img class="h-8 text-white" :src="champ" alt="champ.png" />
      </div>
      <div id="second">
        <img class="h-8 text-white" :src="glove" alt="glove.png" />
        <!-- <component :is=""></component> -->
      </div>
      <div id="third">
        <img class="h-8 text-white" :src="judo" alt="judo.png" />
        <!-- <component :is=""></component> -->
      </div>
      <div id="fourth">
        <img class="h-8 text-white" :src="mt" alt="mt.png" />
        <!-- <component :is=""></component> -->
      </div>
      <div id="fifth">
        <img class="h-8 text-white" :src="punch" alt="punch.png" />
        <!-- <component :is=""></component> -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { storeApp } from "@/store";
import { computed } from "vue";

const load = computed(() => storeApp.state.loading)

const champ = require("@/assets/svg/champ.png");
const glove = require("@/assets/svg/glove.png");
const judo = require("@/assets/svg/judo.png");
const mt = require("@/assets/svg/mt.png");
const punch = require("@/assets/svg/punch.png");

</script>

<style>
@-webkit-keyframes waterfall {
  0% {
    opacity: 0;
    -webkit-transform: translateY(-250%);
    transform: translateY(-250%);
  }
  40%,
  60% {
    opacity: 1;
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    -webkit-transform: translateY(250%);
    transform: translateY(250%);
  }
}
@keyframes waterfall {
  0% {
    opacity: 0;
    -webkit-transform: translateY(-250%);
    transform: translateY(-250%);
  }
  40%,
  60% {
    opacity: 1;
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    -webkit-transform: translateY(250%);
    transform: translateY(250%);
  }
}
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.566);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.waterfall div {
  -webkit-animation: waterfall 1.5s infinite;
  animation: waterfall 1.5s infinite;
  height: 20px;
  color: rgba(255, 255, 255, 0.802);
  left: 50%;
  margin-top: -10px;
  opacity: 0;
  position: absolute;
  top: 50%;
  width: 20px;
  font-size: 25px;
}
.waterfall #fifth {
  -webkit-animation-delay: 1.25s;
  animation-delay: 1.25s;
  margin-left: -90px;
}
.waterfall #first {
  -webkit-animation-delay: 0.25s;
  animation-delay: 0.25s;
  margin-left: -50px;
}
.waterfall #fourth {
  -webkit-animation-delay: 1s;
  animation-delay: 1s;
  margin-left: -15px;
}
.waterfall #second {
  -webkit-animation-delay: 0.5s;
  animation-delay: 0.5s;
  margin-left: 25px;
}
.waterfall #third {
  -webkit-animation-delay: 0.75s;
  animation-delay: 0.75s;
  margin-left: 60px;
}
</style>
